<template>
  <section class="hero is-primary is-bold" id="hero">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column">
            <p class="is-size-1 has-text-right-mobile is-size-3-mobile">
              <span class="fancy">tinythoughts</span> is
              a <strong class="has-text-white-ter">sentence a day</strong> journal
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="browserphone">
              <div class="browserphone-browser">
                <div class="mask">
                  <img
                    src="tinythoughts_files/d2ca88f1-2e71-4d35-8520-23f9ef27b84b.png"
                    alt="Screenshot of App in Browser" class="mask-img"
                  >
                </div>
              </div>
              <div class="browserphone-iphone">
                <div class="mask">
                  <img
                    src="tinythoughts_files/069ff293-6eb7-42de-89a0-8b10eb75d4cf.png"
                    alt="Screenshot of iPhone App"
                    class="mask-img"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-download-links />
      </div>
    </div>
  </section>
</template>

<script>
import AppDownloadLinks from './AppDownloadLinks.vue'

export default {
  name: 'WelcomeHero',
  components: {
    AppDownloadLinks
  }
};
</script>

<style scoped lang="scss">
.container {
  max-width: 1020px;
}

.columns {
  margin-top: 50px;
}

.browserphone {
  position: relative;
}

.browserphone-iphone{
  z-index: 2;
  position: absolute;
  display: inline-block;
  bottom: 0;
  right: 0;
  background: linear-gradient(#f4f4f4,#f2f2f2);
  box-shadow:
    inset 0 0 1px 1px #dbdcdd,
    inset 0 0 1px 4px #efefef,
    inset 0 0 0 5px #fff,
    inset 0 0 0 6.5px #edf1f2,
    inset 5px 0 7px 5px #fff,
    inset -5px 0 7px 5px #fff;
  border-radius: 35px;
  padding:50px 15px 60px;

  &:before{
    content: "";
    width: 52px;
    height: 7px;
    border-radius: 10px;
    position: absolute;
    box-shadow:
      inset 0 4px 3px 0 #e6e6e6,
      inset 0 0 0 2px #ececec;
    top: 25px;
    left: calc(50% - 26px);
  }

  &:after{
    content: "";
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    box-shadow:
      inset 0 -2px .2px 0 #d5d5d5,
      inset 0 0 0 2.5px #e8e8e8;
    bottom: 14px;
    left: calc(50% - 19px);
  }

  .mask {
    width: 210px;
    min-height: 310px;
    max-height: 400px;
  }
}

.browserphone-browser {
  border-radius: 6px;
  background-size: 60px;
  box-shadow: 0 10px 20px rgba(40,39,66,.06);
  overflow: hidden;
  width: 900px;
  z-index: 2;
  background-size: auto 30px;
  position: relative;
  box-shadow: 0 15px 19px 6px rgba(0,0,0,.05);

  &:before {
    content: "";
    height: 30px;
    line-height: 30px;
    display: block;
    width: 100%;
    position: relative;
    background: linear-gradient(-180deg,#fafbfc 0,#f1f4f7 100%);
  }

  &:after {
    content: "";
    width: 12px;
    height: 12px;
    background: #e2e5e5;
    position: absolute;
    border-radius: 50%;
    top: 10px;
    left: 8px;
    box-shadow: 18px 0 0 #e2e5e5,36px 0 0 #e2e5e5;
  }

  .mask {
    min-height: 490px;
    max-height: 580px;
  }
}

@media screen and (max-width: 820px) {
  .browserphone-browser {
    margin-left: 100px;
  }

  .browserphone-iphone {
    right: initial;
  }

  .columns {
    margin-top: 20px;
  }
}
</style>
